export default "__VITE_ASSET__7632853a__"